var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3 py-4",class:_vm.backgroundColor},[_c('v-footer',{staticClass:"mx-auto",attrs:{"dark":"","color":_vm.backgroundColor,"max-width":"1080"}},[_c('h3',{staticClass:"text-center text-body-2 mx-auto",domProps:{"textContent":_vm._s(
                'Copyright © 2021 Dinas Sosial Kota Banjarmasin. All rights reserved.'
            )}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }